import { logoutReturnTo, nativeLogoutOpts } from "@/native/auth";
import { clearShareAuth } from "@/native/shareAuthMirror";
import { clearSandboxProvisionCache } from "@/pages/canvas/nodes/widgets/terminal/sandboxProvision";
import { clearSessionQueryCaches } from "@/queryPersistence";
import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";

const Logout: React.FC = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    // Drop any cached sandbox terminal URLs/tokens before the Auth0 redirect tears down module state.
    clearSandboxProvisionCache();
    // Remove the Share Extension's mirrored token before the session ends.
    void clearShareAuth();
    // Wipe the persisted query cache so the next login on this browser can't
    // see this session's data.
    clearSessionQueryCaches();
    logout({
      logoutParams: { returnTo: logoutReturnTo() },
      ...nativeLogoutOpts(),
    });
  }, []);

  return null;
};

export default Logout;
